import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';
import {Card, Loader, Input, Button, Form, Popup, Icon} from 'semantic-ui-react';
import {setErrorMessage, clearErrorMessage} from '../../../../../../common/components/form/common';
import {numbersDictionary} from '../../../../../../common/dictionaries/classification';
import {hasAccessPermission} from '../../../../../../common/permissions/validations';
import {getSystemParameterValue} from '../../../../../../common/util/parametersUtils';
import {resources, scopes} from '../../../../../../common/permissions/dictionary';
import {ICC_MAD_PARAMETERS} from '../../../../../../common/forms';
import {paths} from '../../../../../../common/dictionaries/urls';
import {Actions} from '../../../../../../common/actions';
import './index.scss';

const groups = ['A', 'B', 'C', 'D', 'E'];

class SafetyStockModal extends Component {
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.IccMatrixParameters,
        scopes.See
      ) &&
      !hasAccessPermission(
        this.props.permissions,
        resources.IccMatrixParameters,
        scopes.Edit
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchIccParameters();
    this.props.fetchSystemParameter('AFR');
  }

  onCancelClick() {
    this.props.navigateBack();
  }

  renderSafetyStockMadCalculatedValue(groupName) {
    const {madParameters} = this.props;
    const madValues = madParameters || {};
    const name = madValues[`salesSafetyStockMad${groupName}`];
    return <div>{name}</div>;
  }

  onSubmit(formValues) {
    const floatValues = {};
    Object.keys(formValues).forEach((value) => {
      floatValues[value] = parseFloat(formValues[value]);
    });
    return this.props.saveIccParameters(floatValues);
  }

  cancelClick() {
    this.props.navigateTo(paths.IccParameters);
  }

  renderSaveButton() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.IccMatrixParameters,
        scopes.Edit
      )
    ) {
      return null;
    }

    const {loading, submitting} = this.props;
    return (
      <Button
        primary
        type='submit'
        className='toyota-primary'
        disabled={submitting || loading}
      >
        Guardar
      </Button>
    );
  }

  renderData() {
    const {loading} = this.props;
    if (loading) {
      return <Loader active inline='centered' />;
    }

    return <table><tbody>{this.renderGroups()}</tbody></table>;
  }

  renderGroups() {
    const rows = [];
    groups.forEach((group) => {
      const columns = Object.entries(numbersDictionary).map(
        ([number, numberName]) => {
          return (
            <td key={`${group}${number}`}>
              {this.renderGroup(
                `${group}`,
                `${group}${number}`,
                `${group}${numberName}`
              )}
            </td>
          );
        }
      );
      rows.push(<tr key={`${group}`}>{columns}</tr>);
    });
    return rows;
  }

  renderGroup(group, title, groupName) {
    return (
      <table className='icc-group'>
        <thead>
          <tr className={`title-group ${group}`}>
            <th colSpan={2}>{title}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Manual</td>
            <td>
              <Field
                name={`manualSafetyStockMad${groupName}`}
                component={Input}
                required
                maxLength='10'
                type='number'
                min='0'
                step='0.01'
                pattern='^\d+(?:\.\d{1,2})?$'
                disabled={
                  !hasAccessPermission(
                    this.props.permissions,
                    resources.IccMatrixParameters,
                    scopes.Edit
                  )}
                onInvalid={(event) =>
                  setErrorMessage(
                    'Por favor, llene este campo siguiendo el formato 0.00',
                    event
                  )
                }
                onInput={(event) => clearErrorMessage(event)}
              />
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>Calculado Ventas</td>
            <td className='mad-calculated'>
              {this.renderSafetyStockMadCalculatedValue(groupName)}
            </td>
          </tr>
        </tfoot>
      </table>
    );
  }

  render() {
    const {handleSubmit, submitting, systemParameters} = this.props;

    return (
      <Form
        className='icc-form'
        onSubmit={handleSubmit(this.onSubmit.bind(this))}
        loading={submitting}
      >
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={() => this.onCancelClick()} />
              <h2>Cálculo Safety Stock MAD</h2>
              <Popup
                trigger={
                  <Icon link name='info circle' color='blue' size='big' />
                }
                on='click'
                position='bottom left'
                inverted
              >
                <div>
                  Fórmula utilizada: S/S MAD = (((Fluctuación máxima de la
                  demanda * AFR ) - MAD) / MAD) Donde: AFR ={' '}
                  {getSystemParameterValue(systemParameters, 'AFR')}%
                </div>
              </Popup>
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  disabled={submitting}
                  onClick={() => this.cancelClick()}
                >
                  Cancelar
                </Button>
                {this.renderSaveButton()}
              </div>
            </div>
          </div>
        </Card>

        <Card raised fluid>
          {this.renderData()}
        </Card>
      </Form>
    );
  }
}

export {SafetyStockModal};

const form = reduxForm({
  'form': ICC_MAD_PARAMETERS.name,
  'initialValues': ICC_MAD_PARAMETERS.initialValues,
})(SafetyStockModal);

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.iccmatrix.loading,
    'madParameters': state.iccmatrix.parameters.mad,
    'systemParameters': state.parameters.list,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  fetchIccParameters,
  fetchSystemParameter,
  saveIccParameters,
  navigateTo,
  navigateBack,
} = Actions;

export default connect(mapStateToProps, {
  fetchIccParameters,
  fetchSystemParameter,
  saveIccParameters,
  navigateTo,
  navigateBack,
})(form);
